import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin } from 'lucide-react';
import { COMPANY, NAVIGATION, FOOTER } from '../content';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_rt-energy/artifacts/cw77ddqz_RT.svg" 
                alt="RT Distribution Logo" 
                className="h-10 w-auto"
              />
              <span className="font-bold text-xl text-white">{COMPANY.name}</span>
            </div>
            <p className="text-sm text-gray-400">
              {COMPANY.slogan}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{FOOTER.quickLinks}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm hover:text-green-400 transition-colors">
                  {NAVIGATION.about}
                </Link>
              </li>
              <li>
                <Link to="/partnership" className="text-sm hover:text-green-400 transition-colors">
                  {NAVIGATION.partnership}
                </Link>
              </li>
              <li>
                <Link to="/offices" className="text-sm hover:text-green-400 transition-colors">
                  {NAVIGATION.offices}
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm hover:text-green-400 transition-colors">
                  {NAVIGATION.careers}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{FOOTER.contactTitle}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="mt-1 text-green-400 flex-shrink-0" />
                <span className="text-sm">{COMPANY.address}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} className="text-green-400" />
                <a href={`mailto:${COMPANY.email}`} className="text-sm hover:text-green-400 transition-colors">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{FOOTER.followUs}</h3>
            <div className="flex space-x-4">
              <a
                href={COMPANY.social.linkedin}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-500">
          <p>{FOOTER.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;